module.exports = __webpack_public_path__ + "img/layer-group.3db65d73.svg";